import { render, staticRenderFns } from "./insuranceNotice.vue?vue&type=template&id=0ae2c770&scoped=true"
import script from "./insuranceNotice.vue?vue&type=script&lang=js"
export * from "./insuranceNotice.vue?vue&type=script&lang=js"
import style0 from "./insuranceNotice.vue?vue&type=style&index=0&id=0ae2c770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae2c770",
  null
  
)

export default component.exports